import { render, staticRenderFns } from "./auth-role-dialog.vue?vue&type=template&id=873956f4&scoped=true"
import script from "./auth-role-dialog.vue?vue&type=script&lang=js"
export * from "./auth-role-dialog.vue?vue&type=script&lang=js"
import style0 from "./auth-role-dialog.vue?vue&type=style&index=0&id=873956f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873956f4",
  null
  
)

export default component.exports